<template>
  <button 
    class="sui-button"
    :class="button_classes"
    :disabled="disabled"
    @click="emit('click', $event)"
  >
    <slot></slot>
  </button>
</template>

<!-- TODO: variants: light, primary-icon-left, primary-icon-right, secondary-icon-left, secondary-icon-right, tertiary-icon-left -->

<script setup lang="ts">
  import { toRefs, computed } from 'vue'

  const props = defineProps({
    variant: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'large'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false
    }
  })

  
  const { variant, size, wide, disabled} = toRefs(props)

  const emit = defineEmits(['click'])

  const button_classes = computed(() => {
    return [ `sui-button--${ variant.value }`, `sui-button--${ size.value }`, {  'sui-button--wide': wide.value } ]
  })
</script>

<style scoped lang="scss">
.sui-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 28px;
  gap: 12px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  white-space: nowrap;
  font-family: inherit;
  line-height: 1;

  &--large {
    height: 42px;
    font-size: 18px;
  }

  &--medium {
    height: 40px;
    font-size: 16px;
  }

  &--small {
    height: 38px;
    font-size: 14px;
  }

  &--wide {
    width: 100%;
  }

  &--primary {
    background-color: var(--color-button-default);
    color: var(--color-text-contrast);

    &:hover {
      background-color: var(--color-button-hover);
    }

    &:disabled {
      pointer-events: none;
      border: none;
      color: var(--color-text-secondary);
      background-color: var(--color-button-disabled);
    }
  }

  &--secondary {
    color: var(--color-text-accent);
    border: 1px var(--color-text-accent) solid;
    background-color: transparent;

    &:disabled {
      pointer-events: none;
      border: 1px var(--stroke-cards) solid;
      color: var(--color-text-secondary);
    }
  }

  &--tertiary {
    color: var(--color-text-accent);
    background-color: transparent;

    &:disabled {
      pointer-events: none;
      color: var(--color-text-secondary);
    }
  }
  &--accent {
    background-color: var(--color-button-accent);
    color: var(--color-text-contrast);

    &:hover {
      background-color: var(--color-button-accent-hover);
    }

    &:disabled {
      pointer-events: none;
      border: none;
      color: var(--color-text-secondary);
      background-color: var(--color-button-disabled);
    }
  }
}
</style>
